import {
    Box,
    Typography,
    Grid
} from '@mui/material'
import Icon1 from '../../../assets/mobile-app/mobile-features1.png'
import Icon2 from '../../../assets/mobile-app/mobile-features2.png'
import Icon3 from '../../../assets/mobile-app/mobile-features3.png'
import Icon4 from '../../../assets/mobile-app/mobile-features4.png'
import Icon5 from '../../../assets/mobile-app/mobile-features5.png'
import Icon6 from '../../../assets/mobile-app/mobile-features6.png'
import {Image} from 'antd'
import { useTranslation } from 'react-i18next'

export const SMMobileFeatures: React.FC = () => {

    const { t } = useTranslation()

    const data = [
        {
            'icon': Icon1,
            'title': t('t285'),
            'content': t('t286'),
        },
        {
            'icon': Icon2,
            'title': t('t287'),
            'content': t('t288'),
        },
        {
            'icon': Icon3,
            'title': t('t289'),
            'content': t('t290'),
        },
        {
            'icon': Icon4,
            'title': t('t291'),
            'content': t('t292'),
        },
        {
            'icon': Icon5,
            'title': t('t293'),
            'content': t('t294'),
        },
        {
            'icon': Icon6,
            'title': t('t295'),
            'content': t('t296'),
        },
    ]

    const renderItem = (index: number) => {
        return (
            <Grid item key={index} xs={4}>
                <Box sx={{
                    flex: '1',
                    paddingLeft: '15px',
                    paddingRight: '15px',
                    width: '100%',
                    height: '100%',
                }}>
                    <Box sx={{
                        flex: '1',
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: '10px',
                        paddingLeft: '40px',
                        paddingRight: '40px',
                        paddingTop: '40px',
                        paddingBottom: '40px',
                        alignItems: 'center',
                        boxShadow: '0px 10px 80px 3px #0000001A',
                    }}>
                        <Image src={data[index]['icon']} width={80} height={80} alt='' preview={false}></Image>
                        <Typography fontSize={20} fontWeight={700} color={'#141F39'} paddingTop={'16px'} textAlign={'center'}>
                            {data[index]['title']}
                        </Typography>

                        <Typography fontSize={16} fontWeight={600} color={'#6B6B6B'} paddingTop={'16px'} textAlign={'center'}>
                            {data[index]['content']}
                        </Typography>
                    </Box>
                </Box>
            </Grid>
        )
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                paddingLeft: '55px',
                paddingRight: '55px',
                paddingTop: '60px',
                paddingBottom: '60px',
            }}
        >
            <Typography fontSize={32} fontWeight={700} color={'#141F39'} textAlign={'center'}>
                {t('t284')}
            </Typography>

            <Box sx={{
                paddingTop: '40px',
            }}>
                <Grid container rowSpacing={5}>
                    {data.map((item, index) => (
                        renderItem(index)
                    ))}
                </Grid>
            </Box>

        </Box >
    )
}

// ======================= EXPORT
export default SMMobileFeatures
